import { Reducer } from 'redux';
import { Week, WeekActionTypes } from '../weeks/types';
import { arrayUnique } from './../../utils/sharedHelpers';
import { WeekState } from './types';
import { SharedActionTypes } from '../shared/types';

const initialState: WeekState = {
  data: {
    byId: {},
    allIds: [],
    bySeasonId: {}
  }
};

const reducer: Reducer<WeekState> = (state = initialState, action) => {
  switch (action.type) {
    case WeekActionTypes.CALCULATE_WEEKS: {
      const seasonId = action.payload.seasonId;
      const weeks = action.payload.weeks;

      const byId = {};
      const allIds: number[] = [];

      weeks.forEach((el: Week) => {
        byId[el.id] = el;
        allIds.push(el.id);
      });

      const bySeasonId = {};
      bySeasonId[seasonId] = allIds;

      return {
        ...state,
        data: {
          ...state.data,
          byId: { ...state.data.byId, ...byId },
          allIds: arrayUnique(state.data.allIds.concat(allIds)),
          bySeasonId: { ...state.data.bySeasonId, ...bySeasonId }
        },
        loading: false
      };
    }
    case WeekActionTypes.TOGGLE_WEEK: {
      let el = { ...state.data.byId[action.payload.weekId] };
      el = { ...el, open: !el.open };
      return {
        ...state,
        data: {
          ...state.data,
          byId: { ...state.data.byId, [el.id]: { ...state.data.byId[el.id], ...el } }
        }
      };
    }
    case SharedActionTypes.RESET: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export { reducer as WeekReducer };



// WEBPACK FOOTER //
// ./src/store/weeks/reducer.ts